module.exports = __webpack_public_path__ + "static/media/icon_HTML_W.4171c8a5.svg";